// Builds the Ask PSD chatbot's metadataFilters payload from the dashboard's
// global filter selections. Shared by the full /ask-psd page and the
// floating chat widget so both send identical filters.
export function buildAskPsdMetadataFilters({
  selectedSector,
  selectedMarket,
  selectedProduct,
  selectedProgram,
  selectedFrequency,
  selectedDate,
  selectedYear,
}) {
  const filters = {};

  if (selectedSector?.sectorId != null) {
    filters.sectorId = selectedSector.sectorId;
  }
  if (selectedMarket?.marketId != null) {
    filters.marketId = selectedMarket.marketId;
  }
  if (selectedProduct?.productId != null) {
    filters.productId = selectedProduct.productId;
  }
  if (selectedProgram?.programId != null) {
    filters.programId = selectedProgram.programId;
  }

  const frequency = selectedFrequency?.id;
  const date = selectedDate instanceof Date ? selectedDate : null;

  if (frequency === 'Weekly' && date) {
    filters.frequency = frequency;
    // Week-of-month (1-5), not ISO week-of-year.
    filters.week = Math.ceil(date.getDate() / 7);
    filters.month = date.getMonth() + 1;
    filters.year = selectedYear ?? date.getFullYear();
  } else if (frequency === 'Monthly' && date) {
    filters.frequency = frequency;
    filters.month = date.getMonth() + 1;
    filters.year = selectedYear ?? date.getFullYear();
  } else if (frequency === 'Yearly' && selectedYear != null) {
    filters.frequency = frequency;
    filters.year = selectedYear;
  }

  return filters;
}

// Human-readable labels for the same selections, for display only (e.g. a
// chips bar showing the user which filters are currently scoping the
// chatbot's answers) — mirrors buildAskPsdMetadataFilters' logic but
// returns display strings instead of IDs.
export function buildAskPsdFilterLabels({
  selectedSector,
  selectedMarket,
  selectedProduct,
  selectedProgram,
  selectedFrequency,
  selectedDate,
  selectedYear,
}) {
  const labels = [];
  const sectorLabel = selectedSector?.sectorName || selectedSector?.label;
  const marketLabel = selectedMarket?.marketName || selectedMarket?.label;
  const productLabel = selectedProduct?.productName || selectedProduct?.label;
  const programLabel = selectedProgram?.programName || selectedProgram?.label;

  if (sectorLabel) {
    labels.push(sectorLabel);
  }
  if (marketLabel) {
    labels.push(marketLabel);
  }
  if (productLabel) {
    labels.push(productLabel);
  }
  if (programLabel) {
    labels.push(programLabel);
  }

  const frequency = selectedFrequency?.id;
  const date = selectedDate instanceof Date ? selectedDate : null;
  const year = selectedYear ?? date?.getFullYear();
  const monthName = date
    ? date.toLocaleDateString(undefined, { month: 'short' })
    : null;

  if (frequency === 'Weekly' && date) {
    labels.push(`Week ${Math.ceil(date.getDate() / 7)}, ${monthName} ${year}`);
  } else if (frequency === 'Monthly' && date) {
    labels.push(`${monthName} ${year}`);
  } else if (frequency === 'Yearly' && year != null) {
    labels.push(`${year}`);
  }

  return labels;
}
